import { render, staticRenderFns } from "./VectorMaps.vue?vue&type=template&id=3454ffaa&scoped=true&"
import script from "./VectorMaps.vue?vue&type=script&lang=js&"
export * from "./VectorMaps.vue?vue&type=script&lang=js&"
import style0 from "./VectorMaps.vue?vue&type=style&index=0&id=3454ffaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3454ffaa",
  null
  
)

export default component.exports